import type {TextTrack} from 'common/api/records'

const TIME_MATCHER = /[\t ]*-->[\t ]*/

const lastNonEmptyLineIndex = (lines: string[]): number => {
  let index = lines.length - 1

  while (index >= 0 && !lines[index]) {
    index--
  }

  return index
}

const nextNonEmptyLineIndex = (
  lines: string[],
  position: number
  // isWebVTT: boolean
): number => {
  // if (isWebVTT) {
  //   return position
  // }
  let index = position

  while (!lines[index]) {
    index++
  }

  return index
}

const timeStringToSeconds = (timeString: string): number => {
  const [hours, minutes, secondsAndMS = '0'] = timeString.split(/:/)
  const [seconds, ms = '0'] = secondsAndMS.split(/[.,]/)
  const time =
    parseFloat(hours) * 60 * 60 +
    parseFloat(minutes) * 60 +
    parseFloat(seconds) +
    parseFloat(ms) / 1000

  if (isNaN(time)) {
    return 0
  }

  return time
}

export const parseTracks = (
  input: string,
  options: {target?: string} = {}
): TextTrack[] => {
  const lines = input.split(/(?:\r\n|\r|\n)/gm)
  const isWebVTT = /WEBVTT/.test(lines[0])

  if (isWebVTT) {
    lines.shift()
  }

  const endIndex = lastNonEmptyLineIndex(lines) + 1
  const tracks: TextTrack[] = []
  let iterator = 0

  /* eslint-disable sonar/updated-loop-counter */
  for (
    let i = 0, j = 0;
    endIndex >= 0 ? j < endIndex : j > endIndex;
    i = endIndex >= 0 ? ++j : --j
  ) {
    const textLines: string[] = []

    i = iterator

    if (i >= endIndex) {
      break
    }

    i = nextNonEmptyLineIndex(lines, i /*, isWebVTT*/)

    const id = TIME_MATCHER.test(lines[i]) ? i : parseInt(lines[i++], 10)
    const time = lines[i++].split(TIME_MATCHER)
    const start = timeStringToSeconds(time[0])
    const index = time[1].indexOf(' ')

    if (index !== -1) {
      time[1] = time[1].substring(0, index)
    }

    const end = timeStringToSeconds(time[1])

    while (i < endIndex && lines[i]) {
      textLines.push(lines[i++])
    }

    const text = textLines
      .join('\\N')
      .replace(/\{(\\[\w]+\(?([\w\d]+,?)+\)?)+\}/gi, '')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(
        /&lt;(\/?(font|b|u|i|s))((\s+(\w|\w[\w-]*\w)(\s*=\s*(?:".*?"|'.*?'|[^'">\s]+))?)+\s*|\s*)(\/?)&gt;/gi,
        '<$1$3$7>'
      )
      .replace(/\\N/gi, '<br />')

    iterator = i

    const track: TextTrack = {
      id,
      start,
      end,
      text
    }

    if (options.target) {
      track.target = options.target
    }

    tracks.push(track)
  }

  return tracks
}
